import React from 'react';

import { createRoot } from 'react-dom/client';

import { Main } from './main';
import { forgetUnscopedStorage } from './utils/userStorage';

import './i18n';
import './theme.css';

if (process.env.NODE_ENV !== 'production') {
  console.log('development mode');
}

/* what earlier versions remembered for whoever happened to sit at this
   browser — nobody reads it any more (see userStorage) */
forgetUnscopedStorage();

/* With REACT_APP_MOCK_API=true, MSW answers all API calls with mock
   data (src/mocks/); rendering waits until the worker is ready so no
   request slips through. */
async function enableMockApi() {
  if (process.env.REACT_APP_MOCK_API !== 'true') {
    return;
  }
  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

const root = createRoot(document.getElementById('root'));

/*In React 18+, Strict Mode intentionally runs lifecycle logic twice in development mode.*/
enableMockApi()
  /* A failed mock start must not cost the whole application: without
     this the promise rejects, render never runs and the user faces a
     blank page with nothing but a console message. It happens for
     real — a production build carries no service worker, so building
     one with REACT_APP_MOCK_API=true left exactly that blank page. */
  .catch((error) => {
    console.error(
      'the mock API could not be started; continuing against the real backend',
      error
    );
  })
  .then(() =>
    root.render(
      <React.StrictMode>
        <Main />
      </React.StrictMode>
    )
  );
